
// import { Icon } from '@iconify/react/dist/iconify.js';
// import React, { useState, useEffect } from 'react';
// import ReactApexChart from 'react-apexcharts';
// import { fetchData } from '../../helper/api.interceptor'; // Update this path

// const RevenueReportOne = () => {
//     const [selectedPeriod, setSelectedPeriod] = useState('Yearly');
//     const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
//     const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
//     const [chartData, setChartData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [stats, setStats] = useState({
//         totalEarning: 0,
//         totalExpense: 0,
//         totalProducts: 300,
//         totalCustomer: 50000,
//         totalOrders: 1500,
//         totalSales: 2500000
//     });

//     // Generate years for dropdown (last 5 years)
//     const currentYear = new Date().getFullYear();
//     const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

//     // Months array
//     const months = [
//         { value: 1, label: 'January' },
//         { value: 2, label: 'February' },
//         { value: 3, label: 'March' },
//         { value: 4, label: 'April' },
//         { value: 5, label: 'May' },
//         { value: 6, label: 'June' },
//         { value: 7, label: 'July' },
//         { value: 8, label: 'August' },
//         { value: 9, label: 'September' },
//         { value: 10, label: 'October' },
//         { value: 11, label: 'November' },
//         { value: 12, label: 'December' }
//     ];

//     // Fetch bar chart data using your fetchData utility
//     const fetchChartData = async () => {
//         setLoading(true);
//         setError(null);

//         try {
//             let url = '';
//             if (selectedPeriod === 'Yearly') {
//                 url = `home/get-bar-chart-details?year=${selectedYear}`;
//             } else if (selectedPeriod === 'Monthly') {
//                 url = `home/get-bar-chart-details?year=${selectedYear}&month=${selectedMonth}`;
//             } else if (selectedPeriod === 'Weekly' || selectedPeriod === 'Today') {
//                 // For weekly/today, use yearly data or implement specific endpoints
//                 url = `home/get-bar-chart-details?year=${selectedYear}`;
//             }

//             const response = await fetchData.get(url);

//             if (response && response.result) {
//                 setChartData(response.result);

//                 // Calculate totals from chart data
//                 if (response.result.length > 0) {
//                     const totalEarning = response.result.reduce((sum, item) => sum + (item.totalAmount || 0), 0);
//                     const totalExpense = totalEarning * 0.04; // Example: expense is 4% of earnings

//                     setStats(prev => ({
//                         ...prev,
//                         totalEarning,
//                         totalExpense
//                     }));
//                 }
//             } else {
//                 setError('No data available');
//                 setChartData(generateMockData());
//             }
//         } catch (err) {
//             console.error('Error fetching chart data:', err);
//             setError('Failed to load chart data');
//             setChartData(generateMockData());
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Generate mock data for demonstration
//     const generateMockData = () => {
//         if (selectedPeriod === 'Yearly') {
//             return Array.from({ length: 12 }, (_, i) => ({
//                 month: i + 1,
//                 totalAmount: Math.floor(Math.random() * 100000) + 50000
//             }));
//         } else if (selectedPeriod === 'Monthly') {
//             const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
//             return Array.from({ length: daysInMonth }, (_, i) => ({
//                 day: i + 1,
//                 totalAmount: Math.floor(Math.random() * 5000) + 1000
//             }));
//         }
//         return [];
//     };

//     // Initialize chart options
//     const getChartOptions = () => {
//         const isMonthly = selectedPeriod === 'Monthly';
//         const categories = isMonthly
//             ? chartData.map(item => `Day ${item.day || item.date || (item.month ? `Month ${item.month}` : 'N/A')}`)
//             : chartData.map(item => {
//                 if (item.month) {
//                     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//                     return monthNames[item.month - 1] || `Month ${item.month}`;
//                 }
//                 return 'N/A';
//             });

//         return {
//             chart: {
//                 type: 'bar',
//                 height: 250,
//                 toolbar: {
//                     show: false
//                 }
//             },
//             plotOptions: {
//                 bar: {
//                     horizontal: false,
//                     columnWidth: '70%',
//                     endingShape: 'rounded'
//                 },
//             },
//             dataLabels: {
//                 enabled: false
//             },
//             stroke: {
//                 show: true,
//                 width: 2,
//                 colors: ['transparent']
//             },
//             xaxis: {
//                 categories: categories,
//                 labels: {
//                     style: {
//                         colors: '#6B7280',
//                         fontSize: '12px'
//                     }
//                 }
//             },
//             yaxis: {
//                 title: {
//                     text: 'Amount ($)',
//                     style: {
//                         fontSize: '12px',
//                         color: '#6B7280'
//                     }
//                 },
//                 labels: {
//                     style: {
//                         colors: '#6B7280',
//                         fontSize: '12px'
//                     },
//                     formatter: function (value) {
//                         return '$' + value.toLocaleString();
//                     }
//                 }
//             },
//             fill: {
//                 opacity: 1
//             },
//             colors: ['#4F46E5'],
//             grid: {
//                 borderColor: '#E5E7EB',
//                 strokeDashArray: 4
//             },
//             tooltip: {
//                 y: {
//                     formatter: function (val) {
//                         return '$' + val.toLocaleString();
//                     }
//                 }
//             }
//         };
//     };

//     const getChartSeries = () => {
//         return [
//             {
//                 name: 'Earning',
//                 data: chartData.map(item => item.totalAmount || 0)
//             }
//         ];
//     };

//     // Handle period change
//     const handlePeriodChange = (period) => {
//         setSelectedPeriod(period);
//     };

//     // Handle year change
//     const handleYearChange = (year) => {
//         setSelectedYear(parseInt(year));
//     };

//     // Handle month change
//     const handleMonthChange = (month) => {
//         setSelectedMonth(parseInt(month));
//     };

//     // Format currency
//     const formatCurrency = (amount) => {
//         return new Intl.NumberFormat('en-US', {
//             style: 'currency',
//             currency: 'USD',
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         }).format(amount);
//     };

//     // Fetch data on mount and when filters change
//     useEffect(() => {
//         fetchChartData();
//     }, [selectedPeriod, selectedYear, selectedMonth]);

//     return (
//         <div className="col-xxl-9">
//             <div className="card radius-8 border-0">
//                 <div className="row">
//                     <div className="col-xxl-6 pe-xxl-0">
//                         <div className="card-body p-24">
//                             <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
//                                 <h6 className="mb-2 fw-bold text-lg">Revenue Report</h6>
//                                 <div className="d-flex gap-2">
//                                     {/* Period Selector */}
//                                     <select
//                                         className="form-select form-select-sm w-auto bg-base border text-secondary-light"
//                                         value={selectedPeriod}
//                                         onChange={(e) => handlePeriodChange(e.target.value)}
//                                     >
//                                         <option value="Yearly">Yearly</option>
//                                         <option value="Monthly">Monthly</option>
//                                         <option value="Weekly">Weekly</option>
//                                         <option value="Today">Today</option>
//                                     </select>

//                                     {/* Year Selector (shown for Yearly, Monthly) */}
//                                     {(selectedPeriod === 'Yearly' || selectedPeriod === 'Monthly') && (
//                                         <select
//                                             className="form-select form-select-sm w-auto bg-base border text-secondary-light"
//                                             value={selectedYear}
//                                             onChange={(e) => handleYearChange(e.target.value)}
//                                         >
//                                             {years.map(year => (
//                                                 <option key={year} value={year}>{year}</option>
//                                             ))}
//                                         </select>
//                                     )}

//                                     {/* Month Selector (shown for Monthly) */}
//                                     {selectedPeriod === 'Monthly' && (
//                                         <select
//                                             className="form-select form-select-sm w-auto bg-base border text-secondary-light"
//                                             value={selectedMonth}
//                                             onChange={(e) => handleMonthChange(e.target.value)}
//                                         >
//                                             {months.map(month => (
//                                                 <option key={month.value} value={month.value}>
//                                                     {month.label}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     )}
//                                 </div>
//                             </div>

//                             <ul className="d-flex flex-wrap align-items-center mt-3 gap-3">
//                                 <li className="d-flex align-items-center gap-2">
//                                     <span className="text-secondary-light text-sm fw-semibold">
//                                         Total Earning:
//                                         <span className="text-primary-light fw-bold ms-1">
//                                             {formatCurrency(stats.totalEarning)}
//                                         </span>
//                                     </span>
//                                 </li>
//                                 {/* <li className="d-flex align-items-center gap-2">
//                                     <span className="w-12-px h-12-px radius-2 bg-yellow" />
//                                     <span className="text-secondary-light text-sm fw-semibold">
//                                         Expense:
//                                         <span className="text-primary-light fw-bold ms-1">
//                                             {formatCurrency(stats.totalExpense)}
//                                         </span>
//                                     </span>
//                                 </li> */}
//                             </ul>

//                             <div className="mt-40">
//                                 {loading ? (
//                                     <div className="text-center py-5">
//                                         <div className="spinner-border text-primary" role="status">
//                                             <span className="visually-hidden">Loading...</span>
//                                         </div>
//                                     </div>
//                                 ) : error ? (
//                                     <div className="text-center py-5 text-danger">
//                                         {error}
//                                     </div>
//                                 ) : (
//                                     <ReactApexChart
//                                         options={getChartOptions()}
//                                         series={getChartSeries()}
//                                         type="bar"
//                                         height={250}
//                                         id="revenueChart"
//                                         className="margin-16-minus"
//                                     />
//                                 )}
//                             </div>
//                         </div>
//                     </div>

//                     <div className="col-xxl-6">
//                         <div className="row h-100 g-0">
//                             {/* Total Products */}
//                             <div className="col-6 p-0 m-0">
//                                 <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0">
//                                     <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
//                                         <div>
//                                             <span className="mb-12 w-44-px h-44-px text-primary-600 bg-primary-light border border-primary-light-white flex-shrink-0 d-flex justify-content-center align-items-center radius-8 h6 mb-12">
//                                                 <Icon icon="fa-solid:box-open" className="icon" />
//                                             </span>
//                                             <span className="mb-1 fw-medium text-secondary-light text-md">
//                                                 Total Products
//                                             </span>
//                                             <h6 className="fw-semibold text-primary-light mb-1">
//                                                 {stats.totalProducts.toLocaleString()}
//                                             </h6>
//                                         </div>
//                                     </div>
//                                     <p className="text-sm mb-0">
//                                         Increase by{" "}
//                                         <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
//                                             +200
//                                         </span>{" "}
//                                         this week
//                                     </p>
//                                 </div>
//                             </div>

//                             {/* Total Customer */}
//                             <div className="col-6 p-0 m-0">
//                                 <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-start-0 border-end-0">
//                                     <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
//                                         <div>
//                                             <span className="mb-12 w-44-px h-44-px text-yellow bg-yellow-light border border-yellow-light-white flex-shrink-0 d-flex justify-content-center align-items-center radius-8 h6 mb-12">
//                                                 <Icon
//                                                     icon="flowbite:users-group-solid"
//                                                     className="icon"
//                                                 />
//                                             </span>
//                                             <span className="mb-1 fw-medium text-secondary-light text-md">
//                                                 Total Customer
//                                             </span>
//                                             <h6 className="fw-semibold text-primary-light mb-1">
//                                                 {stats.totalCustomer.toLocaleString()}
//                                             </h6>
//                                         </div>
//                                     </div>
//                                     <p className="text-sm mb-0">
//                                         Increase by{" "}
//                                         <span className="bg-danger-focus px-1 rounded-2 fw-medium text-danger-main text-sm">
//                                             -5k
//                                         </span>{" "}
//                                         this week
//                                     </p>
//                                 </div>
//                             </div>

//                             {/* Total Orders */}
//                             <div className="col-6 p-0 m-0">
//                                 <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-bottom-0">
//                                     <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
//                                         <div>
//                                             <span className="mb-12 w-44-px h-44-px text-lilac bg-lilac-light border border-lilac-light-white flex-shrink-0 d-flex justify-content-center align-items-center radius-8 h6 mb-12">
//                                                 <Icon
//                                                     icon="majesticons:shopping-cart"
//                                                     className="icon"
//                                                 />
//                                             </span>
//                                             <span className="mb-1 fw-medium text-secondary-light text-md">
//                                                 Total Orders
//                                             </span>
//                                             <h6 className="fw-semibold text-primary-light mb-1">
//                                                 {stats.totalOrders.toLocaleString()}
//                                             </h6>
//                                         </div>
//                                     </div>
//                                     <p className="text-sm mb-0">
//                                         Increase by{" "}
//                                         <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
//                                             +1k
//                                         </span>{" "}
//                                         this week
//                                     </p>
//                                 </div>
//                             </div>

//                             {/* Total Sales */}
//                             <div className="col-6 p-0 m-0">
//                                 <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-start-0 border-end-0 border-bottom-0">
//                                     <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
//                                         <div>
//                                             <span className="mb-12 w-44-px h-44-px text-pink bg-pink-light border border-pink-light-white flex-shrink-0 d-flex justify-content-center align-items-center radius-8 h6 mb-12">
//                                                 <Icon
//                                                     icon="ri:discount-percent-fill"
//                                                     className="icon"
//                                                 />
//                                             </span>
//                                             <span className="mb-1 fw-medium text-secondary-light text-md">
//                                                 Total Sales
//                                             </span>
//                                             <h6 className="fw-semibold text-primary-light mb-1">
//                                                 {formatCurrency(stats.totalSales)}
//                                             </h6>
//                                         </div>
//                                     </div>
//                                     <p className="text-sm mb-0">
//                                         Increase by{" "}
//                                         <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
//                                             +$10k
//                                         </span>{" "}
//                                         this week
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default RevenueReportOne;
import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { fetchData } from '../../helper/api.interceptor';

const RevenueReportOne = () => {
    const [selectedPeriod, setSelectedPeriod] = useState('Yearly');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // 🔥 BACKEND DRIVEN STATS (NO UI CHANGE)
    const [stats, setStats] = useState({
        totalEarning: 0,
        totalExpense: 0,
        totalProducts: 0,
        totalCustomer: 0,
        totalOrders: 0,
        totalSales: 0
    });

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

    const months = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' }
    ];

    // 🔥 FETCH DATA (ONLY LOGIC UPDATED)
    const fetchChartData = async () => {
        setLoading(true);
        setError(null);

        try {
            let url = '';
            if (selectedPeriod === 'Yearly') {
                url = `home/get-bar-chart-details?year=${selectedYear}`;
            } else if (selectedPeriod === 'Monthly') {
                url = `home/get-bar-chart-details?year=${selectedYear}&month=${selectedMonth}`;
            } else {
                url = `home/get-bar-chart-details?year=${selectedYear}`;
            }

            const response = await fetchData.get(url);

            if (response?.result) {
                const { chartData, stats } = response.result;

                setChartData(chartData || []);

                setStats({
                    totalEarning: stats.totalSales,
                    totalExpense: stats.totalSales * 0.04,
                    totalProducts: stats.totalProducts,
                    totalCustomer: stats.totalCustomers,
                    totalOrders: stats.totalOrders,
                    totalSales: stats.totalSales
                });
            } else {
                setError('No data available');
            }
        } catch (err) {
            console.error('Chart API Error:', err);
            setError('Failed to load chart data');
        } finally {
            setLoading(false);
        }
    };

    const getChartOptions = () => {
        const isMonthly = selectedPeriod === 'Monthly';
        const categories = isMonthly
            ? chartData.map(item => `Day ${item.day}`)
            : chartData.map(item => {
                const names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                return names[item.month - 1];
            });

        return {
            chart: {
                type: 'bar',
                height: 250,
                toolbar: { show: false }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '70%',
                    endingShape: 'rounded'
                }
            },
            dataLabels: { enabled: false },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            xaxis: { categories },
            yaxis: {
                labels: {
                    formatter: (val) => `${val.toLocaleString()}`
                }
            },
            colors: ['#4F46E5']
        };
    };

    const getChartSeries = () => [
        {
            name: 'Earning',
            data: chartData.map(item => item.totalAmount || 0)
        }
    ];

    const formatCurrency = (amount) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0, // remove paise if you want
        }).format(amount);

    useEffect(() => {
        fetchChartData();
    }, [selectedPeriod, selectedYear, selectedMonth]);

    return (
        <div className="col-xxl-9">
            <div className="card radius-8 border-0">
                <div className="row">
                    <div className="col-xxl-6 pe-xxl-0">
                        <div className="card-body p-24">
                            <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                                <h6 className="mb-2 fw-bold text-lg">Revenue Report</h6>
                                <div className="d-flex gap-2">
                                    <select
                                        className="form-select form-select-sm w-auto bg-base border text-secondary-light yearSelect"
                                        value={selectedPeriod}
                                        onChange={(e) => setSelectedPeriod(e.target.value)}
                                    >
                                        <option value="Yearly">Yearly</option>
                                        <option value="Monthly">Monthly</option>
                                    </select>

                                    <select
                                        className="form-select form-select-sm w-auto bg-base border text-secondary-light yearSelect"
                                        value={selectedYear}
                                        onChange={(e) => setSelectedYear(e.target.value)}
                                    >
                                        {years.map(year => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>

                                    {selectedPeriod === 'Monthly' && (
                                        <select
                                            className="form-select form-select-sm w-auto bg-base border text-secondary-light"
                                            value={selectedMonth}
                                            onChange={(e) => setSelectedMonth(e.target.value)}
                                        >
                                            {months.map(month => (
                                                <option key={month.value} value={month.value}>
                                                    {month.label}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </div>
                            </div>

                            <ul className="d-flex flex-wrap align-items-center mt-3 gap-3">
                                <li className="d-flex align-items-center gap-2">
                                    <span className="w-12-px h-12-px radius-2 bg-primary-600" />
                                    <span className="text-secondary-light text-sm fw-semibold">
                                        Total Earning:
                                        <span className="text-primary-light fw-bold ms-1">
                                            {formatCurrency(stats.totalEarning)}
                                        </span>
                                    </span>
                                </li>
                            </ul>

                            <div className="mt-40">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" />
                                    </div>
                                ) : error ? (
                                    <div className="text-danger text-center py-5">{error}</div>
                                ) : (
                                    <ReactApexChart
                                        options={getChartOptions()}
                                        series={getChartSeries()}
                                        type="bar"
                                        height={250}
                                        id="revenueChart"
                                        className="margin-16-minus"
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ✅ RIGHT SIDE — UI EXACTLY SAME */}
                    <div className="col-xxl-6">
                        <div className="row h-100 g-0">

                            {/* Total Products */}
                            <div className="col-6 p-0 m-0">
                                <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div>
                                            <span className="mb-12 w-44-px h-44-px text-primary-600 bg-primary-light border border-primary-light-white d-flex justify-content-center align-items-center radius-8 h6">
                                                <Icon icon="fa-solid:box-open" />
                                            </span>
                                            <span className="mb-1 fw-medium text-secondary-light text-md">
                                                Total Products
                                            </span>
                                            <h6 className="fw-semibold text-primary-light mb-1">
                                                {stats.totalProducts.toLocaleString()}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Total Customer */}
                            <div className="col-6 p-0 m-0">
                                <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-start-0 border-end-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div>
                                            <span className="mb-12 w-44-px h-44-px text-yellow bg-yellow-light border border-yellow-light-white d-flex justify-content-center align-items-center radius-8 h6">
                                                <Icon icon="flowbite:users-group-solid" />
                                            </span>
                                            <span className="mb-1 fw-medium text-secondary-light text-md">
                                                Total Customer
                                            </span>
                                            <h6 className="fw-semibold text-primary-light mb-1">
                                                {stats.totalCustomer.toLocaleString()}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Total Orders */}
                            <div className="col-6 p-0 m-0">
                                <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-bottom-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div>
                                            <span className="mb-12 w-44-px h-44-px text-lilac bg-lilac-light border border-lilac-light-white d-flex justify-content-center align-items-center radius-8 h6">
                                                <Icon icon="majesticons:shopping-cart" />
                                            </span>
                                            <span className="mb-1 fw-medium text-secondary-light text-md">
                                                Total Orders
                                            </span>
                                            <h6 className="fw-semibold text-primary-light mb-1">
                                                {stats.totalOrders.toLocaleString()}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Total Sales */}
                            <div className="col-6 p-0 m-0">
                                <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-start-0 border-end-0 border-bottom-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div>
                                            <span className="mb-12 w-44-px h-44-px text-pink bg-pink-light border border-pink-light-white d-flex justify-content-center align-items-center radius-8 h6">
                                                <Icon icon="ri:discount-percent-fill" />
                                            </span>
                                            <span className="mb-1 fw-medium text-secondary-light text-md">
                                                Total Sales
                                            </span>
                                            <h6 className="fw-semibold text-primary-light mb-1">
                                                {formatCurrency(stats.totalSales)}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default RevenueReportOne;
